import React from 'react';
import { motion } from 'framer-motion';
import { Music, Sparkles } from 'lucide-react';
export function SectionsPreview() {
  return <section className="py-24 px-6 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-79">
      <div className="max-w-6xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-2xl mx-auto mb-16" data-id="element-81">
          <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-82">
            Two stages. One community.
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-83">
            We're committed to empowering creators from all backgrounds. That's
            why we envision two distinct sections, ensuring each performer
            reaches the right audience.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-10" data-id="element-84">
          {/* General Dance Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="group relative bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 overflow-hidden hover:border-zinc-700 transition-colors" data-id="element-85">
            <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-86">
              <Music className="w-32 h-32 text-zinc-100" data-id="element-87" />
            </div>

            <div className="relative z-10" data-id="element-88">
              <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mb-8" data-id="element-89">
                <Music className="w-6 h-6 text-zinc-300" data-id="element-90" />
              </div>

              <h3 className="font-serif text-3xl mb-4" data-id="element-91">Open Floor</h3>
              <p className="text-zinc-400 leading-relaxed mb-8" data-id="element-92">
                For general dance creators and all styles. A space dedicated to
                the art of movement, from contemporary to hip-hop, ballet to
                breakdance.
              </p>

              <ul className="space-y-3 text-sm text-zinc-500" data-id="element-93">
                <li className="flex items-center gap-2" data-id="element-94">
                  <div className="w-1.5 h-1.5 rounded-full bg-zinc-700" data-id="element-95" />
                  All ages welcome
                </li>
                <li className="flex items-center gap-2" data-id="element-96">
                  <div className="w-1.5 h-1.5 rounded-full bg-zinc-700" data-id="element-97" />
                  Flexible monetization tools
                </li>
                <li className="flex items-center gap-2" data-id="element-98">
                  <div className="w-1.5 h-1.5 rounded-full bg-zinc-700" data-id="element-99" />
                  Supportive community
                </li>
              </ul>
            </div>
          </motion.div>

          {/* Adult Content Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="group relative bg-zinc-900 border border-zinc-800 rounded-3xl p-8 md:p-12 overflow-hidden hover:border-magenta-500/30 transition-colors" data-id="element-100">
            <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-101">
              <Sparkles className="w-32 h-32 text-magenta-500" data-id="element-102" />
            </div>

            <div className="relative z-10" data-id="element-103">
              <div className="flex items-center justify-between mb-8" data-id="element-104">
                <div className="w-12 h-12 bg-magenta-500/10 rounded-full flex items-center justify-center" data-id="element-105">
                  <Sparkles className="w-6 h-6 text-magenta-500" data-id="element-106" />
                </div>
                <span className="px-3 py-1 bg-zinc-800 text-zinc-300 text-xs font-medium rounded-full tracking-wider" data-id="element-107">
                  18+ ONLY
                </span>
              </div>

              <h3 className="font-serif text-3xl mb-4 text-magenta-50" data-id="element-108">
                After Hours
              </h3>
              <p className="text-zinc-400 leading-relaxed mb-8" data-id="element-109">
                For those who explore adult content. A tasteful, secure
                environment ensuring performers reach the right audience for
                more mature avenues of expression.
              </p>

              <ul className="space-y-3 text-sm text-zinc-500" data-id="element-110">
                <li className="flex items-center gap-2" data-id="element-111">
                  <div className="w-1.5 h-1.5 rounded-full bg-magenta-500/50" data-id="element-112" />
                  Age-gated environment
                </li>
                <li className="flex items-center gap-2" data-id="element-113">
                  <div className="w-1.5 h-1.5 rounded-full bg-magenta-500/50" data-id="element-114" />
                  Premium monetization
                </li>
                <li className="flex items-center gap-2" data-id="element-115">
                  <div className="w-1.5 h-1.5 rounded-full bg-magenta-500/50" data-id="element-116" />
                  Discreet & secure
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}